import terms from "./linkBuildingPackages.json";
export { default as pricingNicheTerms } from "./pricingNicheTerms.json";

/** Shared with the static route generator so crawlers see the same commercial terms. */
export const packageTerms = terms;

export const packageOffers = [
  ...packageTerms.map((term) => ({
    name: term.name,
    price: String(term.price),
    currency: "USD",
    description: `${term.links} niche-relevant guest posts with content included, DR ${term.minimumDR}+, ${term.monthlyTraffic}+ monthly organic traffic verified via Ahrefs, custom report, no repeated domains across orders. Average delivery: ${term.deliveryWeeks[0]} to ${term.deliveryWeeks[1]} weeks.`,
  })),
  { name: "Custom Package", currency: "USD", description: "Custom link building scope and pricing supplied by quote." },
];